import React, {Component} from "react";
// import ChuangXingLogo from '../image/atman fish banner.png';
// import AquaOneLogo from "../image/atman_logo.png";
// import TetraFishLogo from "../image/atman_logo.png";
// import RedSeaLogo from "../image/atman_logo.png";
import banner from "../image/banner_compress.jpg";
import {Link} from "react-router-dom";
import FadeInSection from "./FadeInSection";


export default class AboutCompany extends Component {
    render() {
        return <React.Fragment>
            <div className="main">
                <div className="section text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 ml-auto mr-auto"  id="about-us">
                                <FadeInSection>
                                    <h2 className="title">About Chuang Xing</h2>
                                </FadeInSection>
                                <h5 className="description fadeInLeft animated">
                                    <FadeInSection>
                                        <img src={banner} alt="promote banner" className="w-100 mb-3"/>
                                    </FadeInSection>
                                    <FadeInSection>
                                        <b>Chuang Xing</b> aquarium products have won worldwide recognition for its superior quality and service, which include glass aquarium, air pump, water pump, internal & external filter, LED light, heater, aquarium accessory and pet cage. It incorporates multiple well-established brands such as Atman, ViaAqua, Champion and Atec. They are acknowledged by the consumer for unique and excellent quality.
                                        <br/><br/>
                                    </FadeInSection>
                                    <FadeInSection>
                                        Chuang Xing commits to provide the best. The R&D team with the mature technical resource is continuously innovating products with pursuing creativity, practicality, durability, reliability and safety. Its professional has made Chuang Xing leading in the industry in China and other markets. Thanks to its expertise, many products are awarded certificates such as CCC, CE, UL, GS, IEC, PSE, etc. It also commits to upgrade management system to standard ISO 9001 2015.
                                        <br/><br/>
                                    </FadeInSection>
                                    <FadeInSection>
                                        With the mature business in South Asia, Europe and the US, Chuang Xing products continue to expand in other continents. Chuang Xing could meet different demands including OEM, ODM project thanks to its advanced facilities. The organised operation also leads to higher production capacity. Manufacture, storage and logistics under one roof will keep Chuang Xing ahead to serve the global consumer.
                                    </FadeInSection>
                                </h5>

                                <br/>
                            </div>
                        </div>
                        <br/>
                        <br/>

                        <Link to="/catalogue">
                            <button type="button" className="btn btn-success downloadCatalogBtn">Download Catalogue</button>
                        </Link>

                        <div id="contact-us"/>
                        <FadeInSection>
                            <h2 className="title">Contact Chuang Xing</h2>
                        </FadeInSection>
                        <FadeInSection>
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Tel</h4>
                                            <p className="card-text">
                                                <a href="tel: +85224131336">
                                                    +852 2413 1336
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Fax</h4>
                                            <p className="card-text">
                                                <a href="tel: +85224131336">
                                                    +852 2413 1116
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Email</h4>
                                            <p className="card-text">
                                                <a href="mailto: info@chuangxing.com.hk">
                                                    info@chuangxing.com.hk
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Address</h4>
                                            <p className="card-text">
                                                <span className={"font-weight-bold"}>ChuangXing Manufacturing Co., Ltd. </span> <br/>
                                                Flat 04, 12/F,
                                                Cheung Fung Industrial Building,
                                                23-39 Pak Tin Par Street,
                                                Tsuen Wan, N.T., Hong Kong
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </FadeInSection>
                        <FadeInSection>
                            <div className="row">

                            </div>
                        </FadeInSection>
                        <FadeInSection>
                            <div className="row">

                            </div>
                        </FadeInSection>
                        <FadeInSection>
                            <div className="row">

                            </div>
                        </FadeInSection>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }
}
